
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorway-pay",
      function () {
        return require("private-next-pages/motorway-pay.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorway-pay"])
      });
    }
  